import { ReactElement } from 'react';

import AdminLoginForm from '../../components/forms/AdminLoginForm';
import { AnonymousArea } from '../../components/AnonymousArea';
import { Headers } from '../../components/Headers';

import './styles.scss';

export function AdminLoginView(): ReactElement {
  return (
    <AnonymousArea className="admin-login-view">
      <AdminLoginForm className="admin-login-form" />
      <Headers />
    </AnonymousArea>
  );
}
